<template>
   <div class="form-group datatime-picker-component" :id="'datetime-form-group' + _uid">
       <label :for="'datetime' + _uid" v-if="label" v-text="label"></label>
       <input :id="'datetime' + _uid" type="text" class="form-control" v-model="datetime" :placeholder="placeholder">
       <button class="clear-datetime" v-if="clearButton && hasValue" @click="clear()">
           <i class="fa fa-times"></i>
       </button>
   </div>
</template>
<script>

    export default {

        props: {
            value: {
                required: true,
            },
            label: {
                type: String,
                required: false,
                default: ""
            },
            placeholder: {
                type: String,
                required: false,
                default: ""
            },
            withTime: {
                type: Boolean,
                required: false,
                default: true,
            },
            defaultHour: {
                required: false,
                type: Number,
                default: 0,
            },
            defaultMinute: {
                required: false,
                type: Number,
                default: 1,
            },
            inline: {
                required: false,
                type: Boolean,
                default: false,
            },
            clearButton: {
                required: false,
                type: Boolean,
                default: false,
            },
            emitNull: {
                required: false,
                type: Boolean,
                default: false,
            },
            readonly: {
                required: false,
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                datetime: this.value ? moment.utc(this.value).startOf('day').format('YYYY-MM-DD') : null,
                calendar: null,
            }
        },

        mounted() {
            console.log(moment.utc(this.value).format())
            this.init();
        },

        methods: {

            init() {
                this.calendar = flatpickr('#datetime' + this._uid, {
                    enableTime: this.withTime,
                    time_24hr: true,
                    readonly: this.readOnly,
                    defaultHour: this.defaultHour,
                    defaultMinute: this.defaultMinute,
                    dateFormat: this.withTime ? 'Y-m-d H:i:S' : 'Y-m-d',
                    inline: this.inline,
                    onChange: (selectedDates, dateStr, instance) => {
                        if (this.emitNull && dateStr == '') {
                            this.$emit('input', null)
                        } else {
                            this.$emit('input', dateStr)
                        }
                    }
                });
            },

            clear() {
                this.calendar.clear()
            }
        },

        watch: {
            value(value) {
                this.calendar.setDate(value)
            }
        },

        computed: {
            hasValue() {
                return (this.value != '') && (this.value !== null);
            }
        }
    }
</script>
